// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosResponse, AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { asyncScheduler, Observable } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { searchExams } from '../../../apis/exam';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';

const {
  searchExamsActions,
} = actionCreatorsList;

const outputActions = {
  success: searchExamsActions.success,
  failure: searchExamsActions.failure
};

type RequestActionTypes = ActionType<
  typeof searchExamsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const searchExamsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(searchExamsActions.request),
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: true }),
    switchMap((action: RequestActionTypes) => {
      const { limit, page, condition } = action.payload;

      return searchExams(limit, page, condition)
        .then(response => {
          const { list, totalPage, count } = response.data || {};
          return searchExamsActions.success({
            list,
            totalPage,
            page,
            limit,
            count,
          });
        })
        .catch((error: AxiosError) => {
          return searchExamsActions.failure({ error });
        });
    }),
  );
};
